import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import SortableTable from "../Components/SortableTable";
import Title from "../Components/Title";
import { showPopupSnackbar } from "../redux/actions/snackbarActions";
import { getToken } from "../Utils/Common";
import EnvSettings from "../Utils/EnvSettings";
import { useStyles } from "../Utils/Styles";

const server = EnvSettings.server;

function formatDeviceData(data) {
  var arr = [];
  data.forEach((element) => {
    arr.push({
      id: element.id,
      serialNumber: element.serialNumber,
      deviceName: element.deviceName,
      deviceType: element.deviceType === 1 ? "Medibag" : "Sensor Module",
      companyName: element.Company ? element.Company.companyName : "",
    });
  });
  return arr;
}

export default function AdminDevices(props) {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const [devices, setDevices] = useState();
  const dispatch = useDispatch();

  let getDevices = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: getToken() }),
    };
    fetch(server + "/get_admin_devices", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          setDevices(formatDeviceData(result.devices));
        }
      });
  };

  let showDevice = (id) => {
    history.push("/cpanel/devices/" + id);
  };

  useEffect(getDevices, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Button
            onClick={() => {
              history.push("/cpanel/devices/new");
            }}
          >
            {t("adminDevices.newDevice")}
          </Button>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Title>{t("deviceList.header")}</Title>
          {devices ? (
            <SortableTable
              data={{
                headCells: [
                  {
                    id: "serialNumber",
                    numeric: false,
                    disablePadding: false,
                    label: t("deviceList.serial"),
                  },
                  {
                    id: "deviceName",
                    numeric: false,
                    disablePadding: false,
                    label: t("deviceList.name"),
                  },
                  {
                    id: "deviceType",
                    numeric: false,
                    disablePadding: false,
                    label: t("deviceList.type"),
                  },
                  {
                    id: "companyName",
                    numeric: false,
                    disablePadding: false,
                    label: t("deviceList.company"),
                  },
                ],
                defaultSortRow: "serialNumber",
                handleRowClick: showDevice,
                tableData: devices,
                rowsPerPage: 25,
              }}
            />
          ) : undefined}
        </Paper>
      </Grid>
    </Grid>
  );
}
